<template>
  <ViewLayout class="call-template-container">
    <template #default>
      <BaseCard
        title="Kasalar"
        customCardWrapperClass="custom-card-wrapper"
        customCardClass="table-card"
      >
        <BaseInput
          v-for="input in Object.values(bankStore.searchForm)"
          v-bind="input?.props"
          :key="input.key"
          v-model="input.value"
          v-maska="input.mask"
          class="search"
          :rightIcon="SearchIcon"
          hideCloseIcon
          @input="handleFieldInput(input.key)"
        />
        <BaseTable
          :selectable="false"
          :loading="requestState.is('getBanks').sending"
          :columns="dashboardBankColumns"
          :customStyles="{ fontSize: '48px' }"
          columnAutoWidth
          :data="bankStore.banks || []"
        >
        </BaseTable>
        <BasePagination
          :page="bankStore.pagination.page"
          :totalCount="bankStore.pagination.totalCount"
          :totalPages="bankStore.pagination.totalPages"
          @change="handlePagination"
        />
      </BaseCard>
      <div class="dashboard-container full">
        <ChartsArea />
      </div>
    </template>
  </ViewLayout>
</template>

<script setup lang="ts">
import ViewLayout from "@/layouts/ViewLayout.vue";
import {
  BaseTable,
  BasePagination,
  BaseInput,
  BaseCard,
} from "@/components/Base";
import ChartsArea from "./ChartsArea.vue";
import { useBankStore } from "@/stores";
import { SearchIcon } from "@/assets/icons";
import requestState from "@/api/requestState";
import { dashboardBankColumns } from "@/stores/tableData/colums";
import { onBeforeMount, onBeforeUnmount } from "vue";
import generateSearchBankForm from "@/stores/forms/searchBank.form";

const bankStore = useBankStore();

async function handleFieldInput(key: string) {
  if (key === "search") {
    clearTimeout(bankStore.timeoutValue);
    bankStore.pagination.page = 1;
    // Set a new timeout
    bankStore.timeoutValue = setTimeout(async () => {
      try {
        await bankStore.getBanks();
      } catch {}
    }, 300); // Delay in milliseconds (adjust as needed)
  }
}

async function handlePagination(page: number) {
  bankStore.pagination.page = page;
  await bankStore.getBanks(
    bankStore.pagination.page,
    bankStore.pagination.pageSize,
    false,
    false
  );
}

onBeforeMount(async () => {
  bankStore.searchForm = generateSearchBankForm();

  await bankStore.getBanks(
    bankStore.pagination.page,
    bankStore.pagination.pageSize,
    false,
    false
  );
});

onBeforeUnmount(() => {
  bankStore.$reset();
});
</script>

<style lang="scss" scoped>
.call-template-container {
  .call-area {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    & .call-img {
      overflow: hidden;
      border-radius: 50%;
      background-color: white;
    }
    & .call-text {
      @include text-overflow;
    }
  }
  .action-container {
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: flex-end;
    & .action-icons {
      width: 28px;
      color: $secondary;
      cursor: pointer;

      &:hover {
        color: $secondary-dark;
      }
    }
  }
  .template-created {
    display: flex;
    flex-direction: column;
    span {
      &:last-of-type {
        color: $neutral-dark;
        font-size: $text-size-sm;
        font-weight: 400;
      }
    }
  }
  :deep(.custom-card-wrapper) {
    .table-card {
      padding: 0;
      overflow: hidden;
    }
  }
}

.dashboard-container {
  display: grid;
  grid-template-columns: 48% 48%;
  gap: 3%;
  width: 100%;
  & .create-call-now {
    font-size: 24px;
    color: $text-light-200;
    margin: auto;
    cursor: pointer;
    display: flex;
    align-items: center;
    & .right-svg {
      margin-left: 4px;
      width: 42px;
    }
    &:hover {
      color: $text-light;
    }
  }
  :deep(.custom-card-wrapper) {
    .table-card {
      padding: 0;
      overflow: hidden;
    }
  }

  &.full {
    grid-template-columns: 100%;
  }
  &.last {
    grid-template-columns: 100%;
    margin-bottom: 48px;
  }
}

.search {
  padding: 10px;
  width: 100%;
}
</style>
